export default __webpack_public_path__ + "static/15-b10ec99f2f5419b5ccc39a57fc6dc453.jpg";